import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_DYNAMIC_ATTRIBUTES } from './graphql'
import cloneDeep from 'lodash/cloneDeep'

export default {
  async queryDynamicAttributes({ commit }) {
    await apolloProvider.defaultClient
      .query({
        query: QUERY_DYNAMIC_ATTRIBUTES,
        fetchPolicy: 'no-cache',
      })
      .then(({ data: { dynamicAttributes: { dynamicAttributes } = [] } }) => {
        commit('SET_DYNAMIC_ATTRIBUTES', cloneDeep(dynamicAttributes))
      })
  },
}
